import React from "react"

import { Button } from "~components/Explorer"
import Response from "./Response"

import { list, response } from "./Responses.module.scss"

const Responses = ({ endpoint, explorer, microcopy }) => (
  <>
    {endpoint.responses && (
      <div id="response" className={response}>
        <Button explorer={explorer} endpoint={endpoint} />
        <header>
          <h2>
            <a href="#response" data-display-anchor>
              {microcopy.text("reference.titles.response")}
            </a>
          </h2>
        </header>

        <div className={list}>
          {endpoint.responses.map((response) => (
            <Response
              key={response.id}
              microcopy={microcopy}
              response={response}
            />
          ))}
        </div>
      </div>
    )}
  </>
)

export default Responses
